import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Language} from './common/models/language';
import {ToasterConfig} from 'angular5-toaster/dist/src/toaster-config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  toasterConfig: ToasterConfig;

  constructor(private translate: TranslateService) {
    this.initSystemLanguage();

    this.toasterConfig = new ToasterConfig(
      {
        limit: 5,
        positionClass: 'toast-top-right',
        // animation: "toast-top-center"
      });
  }

  initSystemLanguage(): void {
    let systemLanguageCode = localStorage.getItem(Language.SYSTEM_LANGUAGE_CODE_LABEL);
    if (!systemLanguageCode) {
      systemLanguageCode = Language.RUSSIAN.code;
      localStorage.setItem(Language.SYSTEM_LANGUAGE_CODE_LABEL, systemLanguageCode);
    }
    this.translate.setDefaultLang(systemLanguageCode);
    this.translate.use(systemLanguageCode);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts